import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./MobileMenucss.css";

 

const MobileMenu = () => {
  const menuData = [
  { title: "Home", link: "/" },
  { title: "Buy", link: "/properties-for-sale" },
  { title: "Rent", link: "/properties-for-rent" },
   { title: "Sell", link: "/sell-your-property" },
  { title: "New Projects", link: "/new-projects" },
  { title: "Luxury Collection", link: "/luxury-collection" },
  { title: "Developers", link: "/developers" },

  {
    title: "Services",
    link: "#",
    children: [
      { title: "Mortgage Advisory", link: "/mortgage" },
      { title: "Property Management", link: "/property-management" }, 
      { title: "Golden Visa & Property Residency", link: "/golden-visa-and-property-residency" },
    ],
  },
 

  {
    title: "About Us",
    link: "#",
    children: [
      { title: "Our Story", link: "/about-us" },
      { title: "Team", link: "/team" },
      { title: "Testimonials", link: "/testimonials" },
    ],
  },

  { title: "Contact Us", link: "/contact-us" },
];
  const [menuOpen, setMenuOpen] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  const toggleSubmenu = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const closeMenu = () => {
    setMenuOpen(false);
    setOpenIndex(null);
  };

  return (
    <>
      <button className="mobile-nav-toggler" onClick={() => setMenuOpen(true)}>
        ☰
      </button>

      <div
        className={`menu-backdrop ${menuOpen ? "show" : ""}`}
        onClick={closeMenu}
      />

      <nav className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={closeMenu}>
          ✕
        </button>

        <ul className="navigation">
          {menuData.map((item, index) => (
            <li key={index} className={item.children ? "has-children" : ""}>
              <div className="menu-item">
                <Link to={item.link} onClick={closeMenu}>
                  {item.title}
                </Link>

                {item.children && (
                  <span
                    className={`arrowmobile ${openIndex === index ? "rotate" : ""}`}
                    onClick={() => toggleSubmenu(index)}
                  >
                    ▾
                  </span>
                )}
              </div>

              {item.children && (
                <ul className={`submenu ${openIndex === index ? "open" : ""}`}>
                  {item.children.map((child, i) => (
                    <li key={i}>
                      <Link to={child.link} onClick={closeMenu}>
                        {child.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>

        <div className="mobile-extra">
          <div className="button-mobi-sell">
            <Link className="tf-btn primary" to="/contact-us" onClick={closeMenu}>
              List Your Property
            </Link>
          </div>

          <div className="mobi-icon-box">
            <div className="box">
              <span className="icon icon-phone2"></span>
              <div>+971 54 454 4287</div>
            </div>

            <div className="box">
              <span className="icon icon-mail"></span>
              <div>info@nvrealestate.ae</div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default MobileMenu;
